import { IBirthCountry } from 'js/hooks/socket/hooks/useGetBirthCountries/types';
import { ICountryRegion } from 'js/hooks/socket/hooks/useGetRegionsByCountryCode/types';

export const birthCountriesToOptions = (birthCountries: IBirthCountry[]): { key: string; value: string }[] => {
    const sortedCountries = [...birthCountries].sort((a, b) => a.name.localeCompare(b.name));

    return sortedCountries.map(country => ({
        key: country.name,
        value: country.code
    }));
};

export const countryRegionsToOptions = (countryRegions: ICountryRegion[]): { key: string; value: string }[] => {
    const sortedProvinces = countryRegions
        .flatMap(region => region.provinces)
        .sort((a, b) => a.name.localeCompare(b.name));

    return sortedProvinces.map(province => ({
        key: province.name,
        value: province.abbreviation
    }));
};

export const countryCitiesToOptions = (
    countryRegions: ICountryRegion[],
    provinceCode?: string
): { key: string; value: string }[] => {
    if (!provinceCode) {
        return [];
    }

    const sortedCities = countryRegions
        .flatMap(region => region.provinces)
        .filter(province => province.abbreviation === provinceCode)
        .flatMap(province => province.cities)
        .sort((a, b) => a.name.localeCompare(b.name));

    return sortedCities.map(city => ({
        key: city.name,
        value: `${city.officialCode}-${city.name}`
    }));
};
